import React from 'react';
import './PMS.css';
import FMSimage from '../Assets/pre1.jpg'; // First image
import FMSimage2 from '../Assets/pms111.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/pre3.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/pms222.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/pre5.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-card">
            <div className="FMS-container">
                {/* First Section: Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <h1 className="FMS-heading">PREPAID METER SOLUTION</h1>
                        <p className="FMS-description">
                            The Prepaid Meter Solution is designed to reduce electricity usage and foster transparency between providers and customers. Smart meters enable real-time consumption tracking, system monitoring, and automated billing, eliminating manual intervention and empowering users to manage energy efficiently.
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage} alt="Prepaid Meter Solution" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading Between Images */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
                </div>

                {/* Second Section: New Layout for Text and Image */}
                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Programmable Load Profiles:</strong> Captures load profiles, event logs, and bill point registers for detailed tracking.</li>
                                <li><strong>Load Connect/Disconnect:</strong> Automatically manages load based on prepaid balance.</li>
                                <li><strong>Debit Reduction:</strong> Collects customer debits efficiently to minimize financial risk.</li>
                                <li><strong>Smart Recharge:</strong> Enables easy power utilization and recharging at your fingertips.</li>
                                <li><strong>Mains Failure Alerts:</strong> Notifies users of mains failure and no-load conditions.</li>
                                <li><strong>Reduced Paperwork:</strong> Streamlines billing and management for operational efficiency.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: New Image for Key Features */}
                    <div className="FMS-image-container">
                        <img src={FMSimage2} alt="Key Features" className="FMS-image" />
                    </div>
                </div>

                {/* Centered Heading for How it Works */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">How it Works</h2>
                </div>

                {/* Third Section: Layout for How it Works */}
                <div className="FMS-content-container">
                    {/* Left side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage3} alt="How It Works" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Smart meters track energy consumption in real time, capturing programmable load profiles and event logs. Users recharge their accounts via a user-friendly system, and the meter automatically connects or disconnects the load based on the balance. Mains failure and no-load alerts ensure reliability, while automated billing reduces paperwork and enhances transparency.
                        </p>
                    </div>
                </div>

                {/* New Section: Why Choose Us */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Why Choose Our Prepaid Meter Solution</h2>
                </div>

                <div className="FMS-content-container">
                    {/* Left side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            <ul>
                                <li><strong>Transparency:</strong> Provides clear insights into consumption patterns for providers and customers.</li>
                                <li><strong>Energy Savings:</strong> Encourages responsible usage to reduce electricity waste.</li>
                                <li><strong>Operational Efficiency:</strong> Automates billing and monitoring to improve utility management.</li>
                                <li><strong>Customer Convenience:</strong> Offers easy recharging and real-time alerts for seamless energy management.</li>
                                <li><strong>Financial Risk Reduction:</strong> Minimizes unpaid bills through prepaid debit collection.</li>
                            </ul>
                        </p>
                    </div>

                    {/* Right side: Image */}
                    <div className="FMS-image-container">
                        <img src={FMSimage4} alt="Why Choose Prepaid Meter" className="FMS-image" />
                    </div>
                </div>

                {/* New Section: Industries Using Our System */}
                <div className="FMS-bottom-heading">
                    <h2 className="FMS-bottom-text">Industries Using Our System</h2>
                </div>

                <div className="FMS-content-container reverse-order-last">
                    {/* Left side: Image for Industries */}
                    <div className="FMS-image-container">
                        <img src={FMSimage5} alt="Industries Using Prepaid Meter" className="FMS-image" />
                    </div>

                    {/* Right side: Text Content */}
                    <div className="FMS-text">
                        <p className="FMS-description">
                            Our Prepaid Meter Solution is trusted by various sectors for its transparency, efficiency, and cost-saving benefits. These industries rely on our system for optimized energy management:
                            <ul>
                                <li>Utilities & Power Distribution</li>
                                <li>Residential Complexes</li>
                                <li>Commercial Buildings</li>
                                <li>Industrial Facilities</li>
                                <li>Smart Cities</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FMS;